import { useMemo } from "react";
import { FolderPaneHeader } from "../FolderPaneHeader";
import { PlanMoveRow } from "../PlanMoveRow";
import { UnsortedPaneHeader } from "../UnsortedPaneHeader";
import { UNSORTED_FOLDER_OPTION } from "../constants";
import { PaneEmptyState } from "./PaneEmptyState";
import type { SelectedFolderPaneProps } from "./types";

export const SelectedFolderPane = ({
  folder,
  floorPlanIds,
  planNameById,
  staysInFolderNameByPlanId,
  currentFolderNameByPlanId,
  folderOptions,
  isDisabled,
  onRename,
  onMovePlan,
}: SelectedFolderPaneProps) => {
  const moveOptions = useMemo(
    () =>
      folder === null
        ? folderOptions
        : folderOptions.filter((option) => option.value !== folder.key),
    [folderOptions, folder],
  );

  return (
    <section className="flex min-w-0 flex-1 flex-col overflow-hidden rounded-lg border border-gray-200">
      {folder === null ? (
        <UnsortedPaneHeader planCount={floorPlanIds.length} />
      ) : (
        <FolderPaneHeader
          folder={folder}
          planCount={floorPlanIds.length}
          isDisabled={isDisabled}
          onRename={onRename}
        />
      )}
      {floorPlanIds.length === 0 ? (
        <PaneEmptyState isUnsorted={folder === null} />
      ) : (
        <ul className="min-h-0 flex-1 overflow-y-auto">
          {floorPlanIds.map((floorPlanId) => (
            <PlanMoveRow
              key={floorPlanId}
              floorPlanId={floorPlanId}
              planName={planNameById.get(floorPlanId) ?? ""}
              staysInFolderName={
                folder === null
                  ? currentFolderNameByPlanId.get(floorPlanId)
                  : staysInFolderNameByPlanId.get(floorPlanId)
              }
              folderOptions={moveOptions}
              selectedFolderOption={
                folder === null ? UNSORTED_FOLDER_OPTION : undefined
              }
              isDisabled={isDisabled}
              onMovePlan={onMovePlan}
            />
          ))}
        </ul>
      )}
    </section>
  );
};
